import { useEffect } from 'react';

const APP_NAME = 'SkyGIS';

/**
 * Sets the document title and optional meta description.
 *
 * Title pattern: `segment | segment | SkyGIS`
 *
 * @example
 * usePageMeta({ title: ['Upload', 'My Project'] })
 * // → "Upload | My Project | SkyGIS"
 *
 * usePageMeta({ title: ['Dashboard'] })
 * // → "Dashboard | SkyGIS"
 *
 * usePageMeta({ title: ['Dashboard'], description: 'Manage your projects' })
 */
export function usePageMeta({ title, description }: { title: (string | undefined | null)[]; description?: string }) {
  useEffect(() => {
    const segments = title.filter(Boolean) as string[];
    document.title = segments.length > 0 ? [...segments, APP_NAME].join(' | ') : APP_NAME;

    let metaDescription = document.querySelector('meta[name="description"]');
    if (description) {
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.setAttribute('name', 'description');
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute('content', description);
    }

    return () => {
      document.title = APP_NAME;
    };
  }, [title.join('|'), description]);
}
